import { render } from "./ProductOrderButtons.vue?vue&type=template&id=aab93d12"
import script from "./ProductOrderButtons.vue?vue&type=script&lang=js"
export * from "./ProductOrderButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__